/**
 * useCapitalScenarios (CHAP-252).
 */
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../lib/api.js';

export interface ScenarioSource {
  name: string;
  amount: number;
  type: string;
  taxDeductible?: boolean;
  k1?: boolean;
  interestRate?: number;
}

export interface CapitalScenario {
  id: string;
  scenarioKey: string;
  name: string;
  advocate: string | null;
  complexity: string | null;
  isDefault: boolean;
  isActive: boolean;
  sources: ScenarioSource[];
  pros: string[];
  cons: string[];
  total: number;
}

export function useCapitalScenarios(slug: string) {
  return useQuery<{ scenarios: CapitalScenario[] }, Error>({
    queryKey: ['capital-scenarios', slug],
    queryFn: () => apiGet(`/api/c/${slug}/capital-scenarios`),
    enabled: !!slug,
  });
}
